<template>
  <OneClickUpgradeInterface
    :performing-upgrade="performingMembershipUpgrade"
    :upgrade-result="upgradeResult"
    :upgrade-error="upgradeError"
    :finish-upgrade="finishUpgrade"
  >
    <template #succesful-upgrade-content>
      <p class="text-center">
        You now have full access! You will be receiving an email with details
        soon.
      </p>
    </template>
  </OneClickUpgradeInterface>

  <Frame
    v-if="billerOptionEnabled('lifetime', 'lifetime')"
    v-bind="$attrs"
    class="flex flex-col justify-around gap-3 border-2"
    :class="[
      highlighted
        ? 'border-yellow-600 cta-frame'
        : 'border-gray-500 brightness-50',
    ]"
  >
    <p>
      <UButton
        color="gray"
        class="font-bold whitespace-nowrap uppercase"
        size="xl"
      >
        Best Deal
      </UButton>
    </p>
    <div>
      <strong class="block text-xl">Multi-Site</strong>
      <p>Platinum Offer</p>
    </div>
    <p>
      ${{ billerOptionPrice("lifetime", "lifetime") }} One-Time
      <br />
      <span class="text-red-600 line-through">
        ${{ billerOptionOriginalPrice("lifetime", "lifetime") }}
        Monthly
      </span>
    </p>
    <UButton
      class="font-bold whitespace-nowrap text-black bg-gradient-to-b from-green-400 to-green-500"
      variant="soft"
      size="xl"
      @click="performMembershipUpgrade('platinum')"
    >
      Upgrade Now
    </UButton>
  </Frame>
</template>

<script setup>
  defineOptions({
    name: "LifeTimeUpgradeFrameWithButton",
    inheritAttrs: false,
  })

  const {
    billerOptionEnabled,
    billerOptionPrice,
    billerOptionOriginalPrice,
    performingMembershipUpgrade,
    performMembershipUpgrade,
    upgradeError,
    upgradeResult,
  } = useMembersArea()

  defineProps({
    highlighted: {
      type: Boolean,
      default: true,
    },
  })

  const emit = defineEmits(["finish-upgrade"])
  const finishUpgrade = () => {
    emit("finish-upgrade")
  }
</script>
